import styled from 'styled-components';

export const ExtraMessageWithBlurredBg = styled.div`
  position: absolute;
  text-align: center;
  width: var(--bench-width);
  backdrop-filter: blur(64px);
  padding: var(--double-unit);
  border-radius: var(--double-unit);
  background: rgba(var(--c-rgb-neutral-1000), 0.07);
`;
